import { render, staticRenderFns } from "./StatisticsReworksByFacultyIndex.vue?vue&type=template&id=7df02183"
import script from "./StatisticsReworksByFacultyIndex.vue?vue&type=script&lang=js"
export * from "./StatisticsReworksByFacultyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports